(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    const heroVideos = document.querySelectorAll('.js-hero-video');
    heroVideos.forEach(function (heroVideo) {
      heroVideo.play();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
